import { Trans } from "@lingui/macro";
import { UiTypography } from "@smp/ui";
import { useFormikContext } from "formik";
import { FC } from "react";

import { AdvisorAccordion } from "@/screens/app/components/dialogs/dialog_advisor/components/advisor_accordion";
import { ExtraParams } from "@/screens/app/components/dialogs/dialog_advisor/screens/_extra/extra_params";
import { PostParams } from "@/screens/app/components/dialogs/dialog_advisor/screens/_extra/post_params";

import { ICreateFormValues } from "../../create_form.types";
import classes from "./step_confirmation.module.css";

export type IStepConfirmationProps = {
  disabled?: boolean;
};

export const StepConfirmation: FC<IStepConfirmationProps> = ({ disabled }) => {
  const { values } = useFormikContext<ICreateFormValues>();

  return (
    <div className={classes.content}>
      <UiTypography variant="h4">
        <Trans>Did we understand you correctly?</Trans>
      </UiTypography>

      <div className={classes.row}>
        <UiTypography variant="h5" className={classes.row__key}>
          <Trans>Your business, product or service</Trans>
        </UiTypography>

        <UiTypography className={classes.row__value}>
          {values.context.occupation}
        </UiTypography>
      </div>

      <div className={classes.row}>
        <UiTypography variant="h5" className={classes.row__key}>
          <Trans>Your client</Trans>
        </UiTypography>

        <UiTypography className={classes.row__value}>
          {values.context.target_audience}
        </UiTypography>
      </div>

      <div className={classes.row}>
        <UiTypography variant="h5" className={classes.row__key}>
          <Trans>The problem solved</Trans>
        </UiTypography>

        <UiTypography className={classes.row__value}>
          {values.context.problem}
        </UiTypography>
      </div>

      <AdvisorAccordion title={<Trans>Additional parameters</Trans>}>
        <ExtraParams
          classes={{
            group: classes.extraForm,
            row: classes.extraForm__row,
          }}
          disabled={disabled}
        />
      </AdvisorAccordion>

      <AdvisorAccordion title={<Trans>Posts settings</Trans>}>
        <PostParams
          disabled={disabled}
          classes={{
            group: classes.extraForm,
            row: classes.extraForm__row,
            row_col: classes.extraForm__row_col,
            row__col: classes.extraForm__row__col,
            radio: classes.extraForm__radio,
          }}
        />
      </AdvisorAccordion>
    </div>
  );
};
